<div class="kt-card max-w-[370px] w-full mx-auto">
  <form [formGroup]="resetForm" (ngSubmit)="onSubmit()" class="kt-card-content flex flex-col gap-5 p-10">
    <div class="text-center">
      <h3 class="text-lg font-medium text-mono">Your Email</h3>
      <span class="text-sm text-secondary-foreground">Enter your email to reset password</span>
    </div>

    <!-- Error Message -->
    @if (errorMessage) {
      <div class="text-red-500 text-sm italic text-center">
        {{ errorMessage }}
      </div>
    }

    <div class="flex flex-col gap-1">
      <label class="kt-form-label font-normal text-mono">Email</label>
      <input class="kt-input" formControlName="email" placeholder="email@email.com" type="text"
             [ngClass]="{'border-red-500': resetForm.get('email')?.touched && resetForm.get('email')?.invalid}"/>
      @if (resetForm.get('email')?.touched && resetForm.get('email')?.invalid) {
        <span class="text-xs text-red-500">
          Valid email is required
        </span>
      }
    </div>
    
    <button [disabled]="isLoading" class="kt-btn kt-btn-primary flex justify-center grow" type="submit">
      @if (!isLoading) {
        <span>Continue <i class="ki-filled ki-black-right"></i></span>
      } @else {
        <span>Sending...</span>
      }
    </button>

    <div class="text-center mt-2">
      <a class="text-sm link" routerLink="/auth/sign-in">Back to Sign In</a>
    </div>
  </form>
</div>
